const commonReducer = (state = {}, action) => {
      switch (action.type) {
          case "SIDE_MENU":
          return Object.assign({}, state, {
            menuToggle: action.data,
          });
          case "Category1List":
            return Object.assign({}, state, {
              Category1List: action.data,
            });
          case "Category2List":
            return Object.assign({}, state, {
              Category2List: action.data,
            });
        default:
          return state;
      }
    };
    
    export default commonReducer;